import Service from "./abstract/Service";

export default class LocationService extends Service {

  findByZipCodeAndHouseNumber(zipCode, houseNumber, countryId) {
    return this.lookup(env.API_URL + '/location/find-address', {
      zip_code: zipCode,
      house_number: houseNumber,
      country_id: countryId
    });
  }

  findByAddress(zipCode, houseNumber, countryId, street, city) {
    return this.lookup(env.API_URL + '/location/find-coordinates', {
      zip_code: zipCode,
      house_number: houseNumber,
      country_id: countryId,
      street: street,
      city: city
    });
  }

  // Optional autofill: a 500 / network drop must not reject (Sentry
  // unhandledrejection) or trip Service.handleFail's blocking dialog.
  lookup(url, params) {
    return axios
      .get(url, { params })
      .then(resp => (resp && resp.data && !Array.isArray(resp.data) ? resp.data : {}))
      .catch(() => ({}));
  }
}
